/**
 * @generated SignedSource<<b05564a8ca71a35fbfb03c1bb0c430c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookNowCalendarForFacilityQuery$variables = {
  facilityId: string;
};
export type BookNowCalendarForFacilityQuery$data = {
  readonly node: {
    readonly club?: {
      readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"useGetBookingWindowDaysByFacilityId">;
  } | null | undefined;
};
export type BookNowCalendarForFacilityQuery = {
  response: BookNowCalendarForFacilityQuery$data;
  variables: BookNowCalendarForFacilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facilityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookNowCalendarForFacilityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGetBookingWindowDaysByFacilityId"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useGetClubStartOfWeekNumberPatron_club"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookNowCalendarForFacilityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicBookingWindowDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberBookingWindowDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportsPrivate",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarStartDay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4fe2772df54e07bdc3d99ca0c241202f",
    "id": null,
    "metadata": {},
    "name": "BookNowCalendarForFacilityQuery",
    "operationKind": "query",
    "text": "query BookNowCalendarForFacilityQuery(\n  $facilityId: ID!\n) {\n  node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      ...useGetBookingWindowDaysByFacilityId\n      club {\n        ...useGetClubStartOfWeekNumberPatron_club\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useGetBookingWindowDaysByFacilityId on Facility {\n  id\n  publicBookingWindowDays\n  memberBookingWindowDays\n  club {\n    supportsPrivate\n    id\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n"
  }
};
})();

(node as any).hash = "0b25346b764869a08ce19b032d428a08";

export default node;
